import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { getTranslatedString } from 'helpers/i18n';
import InternalComments from './InternalComments';
import PostButton from './PostInternalCommentButton';
import CommentList from './CommentList';
import { postInternalComment } from 'components/landlord_app/maintenance/tickets/store/actions';
import { saveTicket } from 'actions/maintenanceTicketActions';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

const InternalCommentsContainer = ({
  ticketID,
  comments,
  postInternalComment,
  onSubmissionComplete,
  setIsLoading,
  setTicketData,
}) => {
  const validateForm = async (values) => {
    const requiredErrorVerbiage = getTranslatedString('required');
    let validationSchema = {
      internal_notes: Yup.string().required(requiredErrorVerbiage),
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };

  const handleSubmit = (values) => {
    setIsLoading(true);
    postInternalComment(values.maintenance_ticket_id, {
      comment: values.internal_notes,
    }).then((response) => {
      setTicketData(response.value.maintenance_ticket);
      onSubmissionComplete();
    });
  };
  const formName = 'internal_comments';

  return (
    <Fragment>
      <Formik
        initialValues={{
          maintenance_ticket_id: ticketID,
          internal_notes: '',
        }}
        onSubmit={(values) => handleSubmit(values)}
        validate={validateForm}
      >
        {({ handleSubmit, handleChange, errors, touched }) => (
          <VerticalFormWrapper id={formName} onSubmit={handleSubmit}>
            <InternalComments handleChange={handleChange} errors={errors} touched={touched} />
            <PostButton />
          </VerticalFormWrapper>
        )}
      </Formik>
      <CommentList comments={comments} />
    </Fragment>
  );
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = {
  postInternalComment,
  setTicketData: saveTicket,
};

export default connect(mapStateToProps, mapDispatchToProps)(InternalCommentsContainer);
